// https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
import enquire from 'enquire.js';
const InitGlobal = () => {
  // const html = document.getElementsByTagName('html')[0];
  const body = document.body;
  const menuToggle = document.querySelector('.menu-toggle');
  let isMobile = false;
  const initEnquirePc = () => {
    if (menuToggle.getAttribute('aria-expanded') === 'true') {
      menuToggle.click();
    }
    console.info('enquire > PC');
  };
  const initEnquireMobile = () => {
    console.info('enquire > Mobile');
  };
  const initEnquire = () => {
    enquire.register('screen and (max-width:1023px)', {
      match: () => {
        isMobile = true;
        body.classList.add('is-mobile');
        body.classList.remove('is-pc');
        initEnquireMobile();
      },
      unmatch: () => {
        isMobile = false;
        body.classList.remove('is-mobile');
        body.classList.add('is-pc');
        initEnquirePc();
      },
    });
  };
  const initResize = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', `${window.innerHeight}px`);
  };

  window.addEventListener('resize', initResize);
  initResize();
  initEnquire();
};
export default InitGlobal;
